import type { OpsTemplate } from '../types';
import { ACTIVE_OPS_LOGISTICS_BY_ID } from '../catalog/activeLogisticsCatalog';

function assertUnique(list: string[], label: string) {
  const seen = new Set<string>();
  const dups = new Set<string>();
  for (const id of list) {
    if (!id) continue;
    if (seen.has(id)) dups.add(id);
    seen.add(id);
  }
  if (dups.size > 0) {
    throw new Error(`Duplicate ${label} IDs: ${Array.from(dups).join(', ')}`);
  }
}

export function assertValidTemplateIds(t: Pick<OpsTemplate, 'templateId' | 'checkpoints'>): void {
  const checkpoints = (t as any).checkpoints || null;
  const checkpointRefs = (t as any).checkpointRefs || null;

  const checkpointIds = Array.isArray(checkpoints)
    ? checkpoints.map((c: any) => String(c.checkpointId || '').trim())
    : Array.isArray(checkpointRefs)
      ? checkpointRefs.map((c: any) => String(c.checkpointId || '').trim())
      : [];

  const taskIds = Array.isArray(checkpoints)
    ? checkpoints.flatMap((c: any) => (c.tasks || []).map((x: any) => String(x.taskId || '').trim()))
    : [];

  const logisticIds = Array.isArray(checkpoints)
    ? checkpoints.flatMap((c: any) => (c.tasks || []).map((x: any) => String(x.logisticId || '').trim()).filter(Boolean))
    : [];

  if (!String(t.templateId || '').trim()) throw new Error('Template is missing templateId.');
  if (checkpointIds.some(id => !id)) throw new Error('Template has a checkpoint missing checkpointId.');
  if (taskIds.some(id => !id)) throw new Error('Template has a task missing taskId.');

  assertUnique(checkpointIds, 'checkpoint');
  assertUnique(taskIds, 'task');

  const unknown = logisticIds.filter(id => !ACTIVE_OPS_LOGISTICS_BY_ID[id]);
  if (unknown.length > 0) {
    throw new Error(`Template references unknown logistics: ${Array.from(new Set(unknown)).join(', ')}`);
  }
}

